import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddHelpdesk from '../addHelpdesk/addHelpdesk';
import {
  updateHelpdeskData,
    getHelpdeskDataForUpdation,
    getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    helpdeskData: state.ConductCampReducer.helpdeskData,
    leadInfraId: state.ConductCampReducer.leadInfraId,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        documentUploadUrlPublic,
        getHelpdeskDataForUpdation,
        updateHelpdeskData,
        getLeadInfraId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddHelpdesk);
